import { useRef, useState } from 'react';

import useToast from '@/components/Toast/useToast';

import { fileToContentBlock } from '../utils';

export const useFiles = () => {
  const { createToast } = useToast();
  const [files, setFiles] = useState<Set<File>>(new Set());

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const filesToAdd = event.target.files;
    if (!filesToAdd) return;
    const existingFileNames = new Set(Array.from(files).map((f) => f.name));
    const validFiles: Set<File> = new Set();
    const invalidFiles: Set<File> = new Set();
    for (const file of filesToAdd) {
      if (!existingFileNames.has(file.name)) {
        validFiles.add(file);
      } else {
        invalidFiles.add(file);
      }
    }

    if (validFiles.size) {
      setFiles((prev) => new Set([...prev, ...validFiles]));
    }
    if (invalidFiles.size) {
      createToast({
        title: 'Skipped files because they are already uploaded',
        description: Array.from(invalidFiles)
          .map((f) => f.name)
          .join(', '),
        type: 'error',
      });
    }
    event.target.value = '';
  };
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  const handleDeleteFile = (file: File) => {
    setFiles((prev) => {
      const newSet = new Set(prev);
      newSet.delete(file);
      return newSet;
    });
  };

  const getFileContentBlocks = async () => {
    const promises = Array.from(files).map(fileToContentBlock);
    const results = await Promise.all(promises);
    return results;
  };

  return {
    files,
    setFiles,
    fileInputRef,
    handleFileUpload,
    handleUploadClick,
    handleDeleteFile,
    getFileContentBlocks,
  };
};
